/* eslint-disable prettier/prettier */
import toast from "react-hot-toast";
import {
  getSolicitudes,
  GetAllCatalogos,
  getInformacionAdicional,
  postCreateSolicitud,
  AgregarDocumentos,
  GetAllIntentosSolicitud,
  InsertIntentosSolicitud,
  ValidarSolicitudPorCorreo,
  ContarNotificacionesNoLeidas,
  GetNotificacionesPendientesSeparadas,
  ObtenerSolicitud,
  MarcarComoLeida,
  MarcarNotificacionesComoLeidasPorSolicitud,
  GetNotificacionesPorSolicitud,
  ActualizarEstadoDocumentoSolicitud,
  AgregarDocumentacionAdministrativa,
  ObtenerDocumentacionCompletaArchivos,
  ActualizarEstadoDocumentacionClinica,
  ActualizarEstadoDocsReunionNacional,
  ActualizarEstadoDocsReunionBoston,
  ActualizarEstadoEstudioSE,
  EliminarDocumentoPorTabla,
  ActualizarObservacionSolicitud,
  AgregarDocumentoPorTabla,
  postAgregarEstudio,
  ActualizarSolicitudAExpediente,
  UpdateSolicitud,
  CambiarEstatusBorradoSolicitud,
  ObtenerSolicitudesBorradas,
} from "../apis";
import axios from "axios";
import validator from "validator";
import { map, orderBy, truncate } from "lodash";

import { store } from "../store";

import {
  setData,
  isLoading,
  setCatalogos,
  setInformacionI,
  setIsloadingCreacion,
  setIsloadingExito,
  setMessageCreacion,
  setDataIntentosSolicitud,
  SetisloadingIntentoSolicitud,
  setNotificacionesNoLeidas,
  setNotificacionesSeparadas,
  setisloadingNotificacionesSeparadas,
  setDetalleSolitud,
  setisloadingdetalleSolicitud,
  cleanMessageCreacion,
  setNotificaciones,
  UpdateDetalleSolitudEstatusDocumentos,
  setDocumentacionSolicitud,
  resetDocumentacionSolicitud,
  UpdateStatusArchivos,
  updateDeleteSolicitudes,
  setisloadingGaleria,
  setProcesoTerminadoExitoso
} from "./solicitudesSlice";

import { ObtenerGaleria, ObtenerGaleriaExcel } from "../galeria/galeriaActions";

export const getNotificacionesXsolicitud = (id) => async (dispatch) => {
  const token = store.getState().login.token;
  dispatch(
    setNotificaciones({
      id: id,
      estatus: true,
      data: null,
    })
  );
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  var data = {
    idSolicitud: id,
  };
  axios
    .get(GetNotificacionesPorSolicitud().concat("?idSolicitud=").concat(id), header)
    .then((response) => {
      var dattt = null;
      if (response.data.code === "Ok") {
        dattt = response.data.data;
      }
      dispatch(
        setNotificaciones({
          id: id,
          estatus: false,
          data: dattt,
        })
      );
      MarcarNotificacionComoLeida(dispatch, id);
    })
    .catch((error) => {
      dispatch(
        setNotificaciones({
          id: id,
          estatus: false,
          data: null,
        })
      );
    });
};

export function MarcarNotificacionComoLeida(dispatch, id) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  const data = {
    idSolicitud: id,
  };
  axios
    .post(MarcarNotificacionesComoLeidasPorSolicitud(), data, header)
    .then((response) => {
      getTotalNotificacionesNoLeidas(dispatch);
    })
    .catch((error) => {});
}

export function MarcarSolicitudLeido(dispatch, id) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  const data = {
    idSolicitud: id,
  };
  axios
    .put(MarcarComoLeida(), data, header)
    .then((response) => {})
    .catch((error) => {});
}

export function getObtenerSolicitud(dispatch, id) {
  const token = store.getState().login.token;
  dispatch(setisloadingdetalleSolicitud(true));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(ObtenerSolicitud().concat(`/${id}`), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setDetalleSolitud(response.data.data));
        dispatch(setisloadingGaleria(true));
        ObtenerGaleria(dispatch, response.data.data.idSolicitud);
      }
      dispatch(setisloadingdetalleSolicitud(false));
    })
    .catch((error) => {
      dispatch(setisloadingdetalleSolicitud(false));
    });
}

export const obtenerSolicitudExcel = async (id) => {
  const token = store.getState().login.token;
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(ObtenerSolicitud().concat(`/${id}`), header);
    if (response.data.code === "Ok") {
      const galeria = await ObtenerGaleriaExcel(response.data.data.idSolicitud);
      const detalleSolicitud = { ...response.data.data, galeria: galeria };
      return detalleSolicitud;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export function getMostrarNotificaciones(dispatch) {
  const token = store.getState().login.token;
  dispatch(setisloadingNotificacionesSeparadas(true));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .get(GetNotificacionesPendientesSeparadas(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setNotificacionesSeparadas(response.data.data));
      }
      dispatch(setisloadingNotificacionesSeparadas(false));
    })
    .catch((error) => {
      dispatch(setisloadingNotificacionesSeparadas(false));
    });
}

export function getTotalNotificacionesNoLeidas(dispatch) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(ContarNotificacionesNoLeidas(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setNotificacionesNoLeidas(response.data.data));
      }
    })
    .catch((error) => {});
}

//Proceso intentos de solicitud
export function getAllIntentosSolicitud(dispatch) {
  const token = store.getState().login.token;
  dispatch(SetisloadingIntentoSolicitud(true));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .get(GetAllIntentosSolicitud(), header)
    .then((response) => {
      if (response.data.code === "Ok") {
        var dataa = orderBy(response.data.data, ["idSolicitud"], ["desc"]);
        dataa = map(dataa, (item) => {
          return {
            precandidato: `${item.nombreCandidato} ${item.aPaternoCandidato} ${item.aMaternoCandidato}`,
            llena: `${item.nombreLlena} ${item.aPaternoLlena} ${item.aMaternoLlena}`,
            ...item,
          };
        });
        dispatch(setDataIntentosSolicitud(dataa));
      }
      dispatch(SetisloadingIntentoSolicitud(false));
    })
    .catch((error) => {
      dispatch(SetisloadingIntentoSolicitud(false));
    });
}

//Porceso solicitudes
export function getSolicitudesT(dispatch, filtros) {
  const token = store.getState().login.token;
  dispatch(isLoading(true));
  dispatch(setData([]));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  var data = {
    fechaAplicacion: filtros?.fechaAplicacion,
    fechaNacimiento: filtros?.fechaNacimiento,
    idParentescoCandidato: filtros?.idParentescoCandidato,
    idSolicitudLlenoFormato: filtros?.idSolicitudLlenoFormato,
    idSolicitudNombreMenor: filtros?.idSolicitudNombreMenor,
    esExpediente: filtros.esExpediente,
  };

  axios
    .post(getSolicitudes(), data, header)
    .then((response) => {
      if (response.data.code === "Ok") {
        var dataa = orderBy(response.data.data, ["idSolicitud"], ["desc"]);
        dispatch(setData(dataa));
      }
      dispatch(isLoading(false));
    })
    .catch((error) => {
      dispatch(isLoading(false));
    });
}
export function getCatalogosT(dispatch) {
  const token = store.getState().login.token;
  axios
    .get(GetAllCatalogos(), {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setCatalogos(response.data.data));
      }
    })
    .catch((error) => {});
}

export function getInformacionInicial(dispatch, esExpediente) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .get(getInformacionAdicional(), {
      ...header,
      params: { esExpediente: esExpediente }, // ✅ aquí van los query params
    })
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setInformacionI(response.data.data));
      }
    })
    .catch((error) => {});
}

export function CreateSolicitud(dispatch, dataSolicitud) {
  const token = store.getState().login.token;
  dispatch(cleanMessageCreacion());

  dispatch(setIsloadingCreacion(true));
  let id = toast.loading("Procesando solicitud, por favor espere...");
  dispatch(
    setMessageCreacion({
      type: "warning",
      message: "Inicia proceso de registro para la solicitud",
    })
  );
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .post(postCreateSolicitud(), dataSolicitud.data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        toast.success("Creación exitosa!");
        SubirArchivos(dispatch, dataSolicitud, response.data.data, token);
      } else {
        toast.error("Ocurrio un error ");
        dispatch(
          setMessageCreacion({
            type: "error",
            message:
              "No es posible procesar la solicitud en estos momentos, por favor intente mas tarde",
          })
        );
      }
    })
    .catch((error) => {
      dispatch(
        setMessageCreacion({
          type: "error",
          message:
            "No es posible procesar la solicitud en estos momentos, por favor intente mas tarde",
        })
      );
      toast.remove(id);
    });
}

export function SubirArchivos(dispatch, dataSolicitud, idsolicitud) {
  const token = store.getState().login.token;
  dispatch(setIsloadingCreacion(true));
  let id = toast.loading("Procesando documentos, por favor espere...");
  var filesAdministrativos = [...dataSolicitud.files.docAdministrativa];
  var filesClinicos = [...dataSolicitud.files.docClinica];

  let formData = new FormData();
  formData.append("idsolicitud", idsolicitud); // ID de la solicitud

  let listaEstudios = [];

  filesClinicos
    .filter((item) => item.file) // 👈 solo con archivo válido
    .forEach((item, index) => {
      listaEstudios.push({
        NombreArchivo: item.file.name,
        Titulo: item.titulo,
      });
      formData.append("doc_clinica", item.file);
    });

  formData.append("listaArchivos", JSON.stringify(listaEstudios));

  filesAdministrativos.forEach((item, index) => {
    formData.append(item.titulo, item.file);
  });

  const header = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .post(AgregarDocumentos(), formData, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Ok") {
        dispatch(
          setMessageCreacion({
            type: "success",
            message: "✅ Su solicitud y documentos fueron enviados con éxito",
          })
        );
        dispatch(
          setMessageCreacion({
            type: "success",
            message: "En breve recibirá una respuesta",
          })
        );
        dispatch(setMessageCreacion(""));
        dispatch(setIsloadingExito(true));
        dispatch(setProcesoTerminadoExitoso(true));
      } else {
        toast.error("Ocurrio un error ");
        dispatch(
          setMessageCreacion({
            type: "error",
            message:
              "No es posible procesar la documentacion en estos momentos, por favor intente mas tarde ",
          })
        );
      }
    })
    .catch((error) => {
      dispatch(
        setMessageCreacion({
          type: "error",
          message:
            "No es posible procesar la solicitud en estos momentos, por favor intente mas tarde ",
        })
      );
      toast.remove(id);
    });
}

export function RegistrarIntentoSolicitud(data) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  const datosFormulario = {
    idSolicitud: 0,
    idComoSeEntero: data.idComoSeEntero,
    comoSeEnteroEspecif: data.comoSeEnteroEspecif,
    fechaAplicacion: data.fechaAplicacion,
    aPaternoLlena: data.aPaternoLlena,
    aMaternoLlena: data.aMaternoLlena,
    nombreLlena: data.nombreLlena,
    idParentescoCandidato: data.idParentescoCandidato,
    celularContacto: data.celularContacto,
    correoContacto: data.correoContacto,
    aPaternoCandidato: data.aPaternoCandidato,
    aMaternoCandidato: data.aMaternoCandidato,
    nombreCandidato: data.nombreCandidato,
    fechaNacimiento: data.fechaNacimiento,
    motivo: data.motivo,
  };

  axios
    .post(InsertIntentosSolicitud(), datosFormulario, header)
    .then((response) => {})
    .catch((error) => {});
}

export const IsValidEmail = async (mail) => {
  const token = store.getState().login.token;
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    const datosFormulario = {
      correo: mail,
    };
    const response = await axios.post(ValidarSolicitudPorCorreo(), datosFormulario, header);
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    return true;
  }
};

export function getInformacionInicialDocumentos(dispatch, idSolicitud) {
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  axios
    .get(ObtenerDocumentacionCompletaArchivos().concat("/").concat(idSolicitud), {
      ...header,
    })
    .then((response) => {
      if (response.data.code === "Ok") {
        dispatch(setDocumentacionSolicitud(response.data.data));
      } else {
        dispatch(resetDocumentacionSolicitud());
      }
    })
    .catch((error) => {
      dispatch(resetDocumentacionSolicitud());
    });
}

export const getInformacionInicialDocumentosExcel = async (idSolicitud) => {
  const token = store.getState().login.token;
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      ObtenerDocumentacionCompletaArchivos().concat("/").concat(idSolicitud),
      {
        ...header,
      }
    );
    if (response.data.code === "Ok") {
      return response.data.data;
    } else {
      const documentos = {
        documentacionClinica: [],
        estudiosSE: [],
        docsReunionNacional: [],
        docsReunionBoston: [],
      };
      return documentos;
    }
  } catch (error) {
    const documentos = {
      documentacionClinica: [],
      estudiosSE: [],
      docsReunionNacional: [],
      docsReunionBoston: [],
    };
    return documentos;
  }
};

//Actualizacion de estatus para documentos y archivos

export const UpdateEstadoDocumentacionSolicitud =
  (idSolicitud, idDocumentacion, valorCampo, tabla) => async (dispatch) => {
    const token = store.getState().login.token;
    const usuario = store.getState().login.usuario;
    let id = toast.loading("Procesando solicitud, por favor espere...");
    try {
      const header = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      };
      var datosFormulario = {};
      var uri = "";
      if (tabla == "clinica") {
        datosFormulario = {
          idDocumentacionClinica: idDocumentacion,
          idSolicitud: idSolicitud,
          idUsuarioEstado: usuario?.idUsuario,
          nuevoEstado: valorCampo,
        };
        uri = ActualizarEstadoDocumentacionClinica();
      }
      if (tabla == "estudio") {
        datosFormulario = {
          idEstudioSE: idDocumentacion,
          idSolicitud: idSolicitud,
          nuevoEstado: valorCampo,
          idUsuarioValida: usuario?.idUsuario,
        };
        uri = ActualizarEstadoEstudioSE();
      }
      if (tabla == "nacional") {
        datosFormulario = {
          idDocReunionNacional: idDocumentacion,
          estado: valorCampo,
          idUsuarioValida: usuario?.idUsuario,
          idSolicitud: idSolicitud,
        };
        uri = ActualizarEstadoDocsReunionNacional();
      }
      if (tabla == "boston") {
        datosFormulario = {
          idDocReunionNacional: idDocumentacion,
          estado: valorCampo,
          idUsuarioValida: usuario?.idUsuario,
          idSolicitud: idSolicitud,
        };
        uri = ActualizarEstadoDocsReunionBoston();
      }
      const response = await axios.put(uri, datosFormulario, header);
      toast.remove(id);
      if (response.data.code === "Ok") {
        toast.success("Actualizacion de estatus exitosa!");
        //hacer el dispatch
        dispatch(UpdateStatusArchivos({ tabla: tabla, valor: valorCampo, id: idDocumentacion }));
      } else {
        toast.error("Ocurrio un error ");
      }
      return response.data.data;
    } catch (error) {
      console.error("Error en la petición:", error);
      toast.remove(id);
      toast.error("Ocurrio un error ");
      return true;
    }
  };
export const ActualizarEstadoDocumento =
  (idSolicitud, nombreCampoBase, valorCampo) => async (dispatch) => {
    const token = store.getState().login.token;
    const usuario = store.getState().login.usuario;
    let id = toast.loading("Procesando solicitud, por favor espere...");
    try {
      const header = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      };
      const datosFormulario = {
        idSolicitud: idSolicitud,
        nombreCampoBase: nombreCampoBase,
        valorCampo: valorCampo,
        idUsuarioValida: usuario?.idUsuario,
      };
      const response = await axios.put(
        ActualizarEstadoDocumentoSolicitud(),
        datosFormulario,
        header
      );
      toast.remove(id);
      if (response.data.code === "Ok") {
        toast.success("Actualizacion de estatus exitosa!");
        //hacer el dispatch
        dispatch(
          UpdateDetalleSolitudEstatusDocumentos({ campo: nombreCampoBase, valor: valorCampo })
        );
      } else {
        toast.error("Ocurrio un error ");
      }
      return response.data.data;
    } catch (error) {
      console.error("Error en la petición:", error);
      toast.remove(id);
      toast.error("Ocurrio un error ");
      return true;
    }
  };

export const ActualizarObservacionesSolicitud =
  (idSolicitud, nombreCampoBase, valorCampo) => async (dispatch) => {
    const token = store.getState().login.token;
    const usuario = store.getState().login.usuario;
    let id = toast.loading("Procesando solicitud, por favor espere...");
    try {
      const header = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      };
      const datosFormulario = {
        idSolicitud: idSolicitud,
        nombreCampo: nombreCampoBase,
        observacionTexto: valorCampo,
        userName: usuario?.nombre,
      };
      const response = await axios.put(ActualizarObservacionSolicitud(), datosFormulario, header);
      toast.remove(id);
      if (response.data.code === "Ok") {
        toast.success("Actualizacion exitosa!");
        //hacer el dispatch
        dispatch(
          UpdateDetalleSolitudEstatusDocumentos({ campo: nombreCampoBase, valor: valorCampo })
        );
      } else {
        toast.error("Ocurrio un error ");
      }
      return response.data.data;
    } catch (error) {
      console.error("Error en la petición:", error);
      toast.remove(id);
      toast.error("Ocurrio un error ");
      return true;
    }
  };
export const AddArchivoestudioSocioeconomico = (idSolicitud, archivo) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    let formData = new FormData();
    formData.append("idSolicitud", idSolicitud);
    formData.append("titulo", archivo.titulo);
    formData.append("userName", usuario?.nombre);
    formData.append("archivo", archivo.file);

    const response = await axios.post(AgregarDocumentacionAdministrativa(), formData, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("Archivo registrado con exito");
      //hacer el dispatch
      dispatch(
        UpdateDetalleSolitudEstatusDocumentos({ campo: archivo.titulo, valor: response.data.data })
      );
    } else {
      toast.error("Ocurrio un error ");
    }
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};

export const AddArchivoSolicitudClinica = (idSolicitud, archivo) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    let formData = new FormData();
    formData.append("userid", usuario?.idUsuario);
    formData.append("idsolicitud", idSolicitud);
    formData.append("titulo", archivo.titulo);
    formData.append("file", archivo.file);

    const response = await axios.post(postAgregarEstudio(), formData, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("Archivo registrado con exito");
      //hacer el dispatch
      getInformacionInicialDocumentos(dispatch, idSolicitud);
      //dispatch(UpdateDetalleSolitudEstatusDocumentos({campo: archivo.titulo, valor: response.data.data}));
    } else {
      toast.error("Ocurrio un error ");
    }
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};

export const AddArchivoSolicitud = (idSolicitud, archivo) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    let formData = new FormData();
    formData.append("tabla", archivo?.tabla);
    formData.append("idSolicitud", idSolicitud);
    formData.append("titulo", archivo.titulo);
    formData.append("userName", usuario?.nombre);
    formData.append("archivo", archivo.file);
    formData.append("idUsuario", usuario?.idUsuario);

    const response = await axios.post(AgregarDocumentoPorTabla(), formData, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("Archivo regisrado con exito");
      //hacer el dispatch
      getInformacionInicialDocumentos(dispatch, idSolicitud);
      //dispatch(UpdateDetalleSolitudEstatusDocumentos({campo: archivo.titulo, valor: response.data.data}));
    } else {
      toast.error("Ocurrio un error ");
    }
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};

export const DelArchivoSolicitud = (idSolicitud, archivo) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    let formData = {
      tabla: archivo?.tabla,
      idArchivo: archivo?.id,
      idSolicitud: idSolicitud,
      nombreCampoGeneral: archivo?.campo,
      rutaArchivo: archivo.ruta,
      userName: usuario?.nombre,
    };
    const response = await axios.post(EliminarDocumentoPorTabla(), formData, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("Archivo eliminado con exito");
      //hacer el dispatch
      getInformacionInicialDocumentos(dispatch, idSolicitud);
      if (archivo?.tabla == "solicitudes") {
        dispatch(UpdateDetalleSolitudEstatusDocumentos({ campo: archivo?.campo, valor: "" }));
      }
      //dispatch(UpdateDetalleSolitudEstatusDocumentos({campo: archivo.titulo, valor: response.data.data}));
    } else {
      toast.error("Ocurrio un error ");
    }
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};

export const ActualizarAExpediente = (idSolicitud) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    let formData = {
      idSolicitud: idSolicitud,
      userName: usuario?.nombre,
    };
    const response = await axios.put(ActualizarSolicitudAExpediente(), formData, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      toast.success("Archivo eliminado con exito");
      //hacer el dispatch
      getObtenerSolicitud(dispatch, idSolicitud);
      //dispatch(UpdateDetalleSolitudEstatusDocumentos({campo: archivo.titulo, valor: response.data.data}));
    } else {
      toast.error("Ocurrio un error ");
    }
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};

export const ActualizarSolicitud = (data) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    let dataEnviar = {
      ...data,
      userName: usuario?.nombre,
    };
    const response = await axios.put(UpdateSolicitud(), dataEnviar, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      getObtenerSolicitud(dispatch, dataEnviar.idSolicitud);
      toast.success("Solicitud editada con éxito");
      return true;
    } else {
      toast.error("Ocurrio un error al editar la solicitud");
      return false;
    }
  } catch (error) {
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return false;
  }
};

export const EliminarSolicitud = (data, estado) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    let dataEnviar = {
      idSolicitud: data?.idSolicitud,
      usuario: usuario?.nombre,
      borrado: estado,
    };

    const response = await axios.put(CambiarEstatusBorradoSolicitud(), dataEnviar, header);
    toast.remove(id);
    if (response.data.code === "Ok") {
      //getObtenerSolicitud(dispatch, dataEnviar.idSolicitud);
      dispatch(updateDeleteSolicitudes(data?.idSolicitud));
      toast.success("Solicitud modificada con éxito");
      return true;
    } else {
      toast.error("Ocurrio un error al modificar la solicitud");
      return false;
    }
  } catch (error) {
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return false;
  }
};

export const SolicitudesBorradas = (esExpediente) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    let dataEnviar = {
      esExpediente: esExpediente,
    };

    const response = await axios.post(ObtenerSolicitudesBorradas(), dataEnviar, header);
    return response.data;
  } catch (error) {
    toast.error("Ocurrio un error ");
    return false;
  }
};
